// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__htAra","default":"styles_default__1-MKW","transparent":"styles_transparent__pP0iT"};